import Component from '@glimmer/component';
import { Input } from '@ember/component';
import { on } from '@ember/modifier';

export interface InputWithFormattingSignature {
  // The arguments accepted by the component
  Args: {
    value: string | null;
    type?: string;
    update?: (value: unknown) => void; // function to call for update
    updateMut?: (value: string) => unknown; // function to reverse val => display
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: HTMLInputElement;
}

function id(val: unknown) {
  return val;
}

export default class InputWithFormatting extends Component<InputWithFormattingSignature> {
  get updateFn() {
    return this.args.update ?? id;
  }
  get updateMutFn() {
    return this.args.updateMut ?? id;
  }
  updateValue = (event: Event) => {
    this.updateFn(this.updateMutFn(event.target?.value as string));
  };

  <template>
    <Input
      {{on "change" this.updateValue}}
      @type={{@type}}
      @value={{@value}}
      ...attributes
    />
  </template>
}
